import { render } from "./SaleCategoryModal.vue?vue&type=template&id=ffee1124"
import script from "./SaleCategoryModal.vue?vue&type=script&lang=js"
export * from "./SaleCategoryModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__